// extracted by mini-css-extract-plugin
export default {"container":"Perpetrator_container__YduuF","page":"Perpetrator_page__RwTjQ","section":"Perpetrator_section__53sSf"};